import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { PrimeReactProvider } from 'primereact/api';
import { Router as Router } from "react-router-dom"
import { Provider } from 'react-redux';
import store, { history } from './store'

import './index.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router history={history}>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </Router>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
